import React, { Component } from 'react';
import MainHeader from '../../../components/common/MainHeader';
import FooterDesktop from '../../../components/common/FooterDesktop';
import Vietnam_7N_8D_Mumbai_Package from '../../../components/package/Vietnam/Vietnam_7N_8D_Mumbai_Package';
import { Helmet } from "react-helmet";
class Vietnam_7N_8D_Mumbai_Page extends Component {
    constructor() {
        super();
        this.state = {
            ReviewersData: [],

        }
    }

    componentDidMount() {
        window.scroll(0, 0);
        const reviewersDataList = [
            {
                Name: "Sheikh Imran",
                ImageName: "Seikh-Imran.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "Dear Akash/Team Adorable,I hope this message finds you well. I am writing to extend my heartfelt gratitude for the exceptional planning and execution of our recent trip to Vietnam. Your meticulous attention to detail and dedication to ensuring a seamless travel experience made this journey truly unforgettable.From the moment we arrived, everything was perfectly arranged—from the comfortable accommodations to the well-organized tours. Your recommendations for local attractions and Lunch/dining experiences on few days added a special touch, allowing us to immerse ourselves in the rich culture and beauty of Vietnam.We particularly appreciated your prompt responses to our queries and the personalized touches you included, which made us feel valued and cared for. Your professionalism and expertise shone through every aspect of the trip, and we are grateful for the peace of mind you provided.Thank you once again for your outstanding service and for making our trip to Vietnam a memorable adventure. We look forward to planning our next journey with you and will gladly recommend your services to friends and family.Best Regards Sheikh Imran and Family",
            },
            {
                Name: "Papri Das",
                ImageName: "Papri-Das.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "We had booked a conducted private tour of Cambodia and Vietnam with Adorable vacations. We had very nice experience, the itinerary was well curated and implemented. We did not face any problems there regarding our transportation, tour,hotels etc.i would strongly recommend them .",
            },
            {
                Name: "Dr. Agniva Chakraborty",
                ImageName: "Agniva-Chakraborty.webp",
                AllternateText: "...",
                Location: "@Mumbai",
                Comment: "Our recent trip to Bali with Adorable Vacation was nothing short of extraordinary. My wife and I were blown away by how well-organized and stress-free everything was. From the moment we set foot on the island, we felt taken care of. The itinerary perfectly balanced relaxation and adventure, allowing us to explore Bali’s breathtaking temples, enjoy scenic rice terraces, and savor romantic dinners by the beach. A special thanks to Mr. Akash Dutta and Ms. Anushka Majumdar for their impeccable planning and personalized service. Their attention to detail ensured our stay was comfortable and memorable. The seamless transfers, beautiful accommodations, and thoughtful touches made our experience even more special. This journey was everything we dreamed of and more. Thank you, Adorable Vacation, for making our Bali getaway one we’ll cherish forever",
            },
            {
                Name: "Swarnali Chakraborty",
                ImageName: "Swarnali- Chakraborty.webp",
                AllternateText: "...",
                Location: "@Kolkata",
                Comment: "Adorable vacation arranged our bali tour according to our budget and meeting up the criterias very well. Thanks for the information guide and arrangements. It was an enjoyable experience.",
            },
        ];

        this.setState({
            ReviewersData: reviewersDataList,
        })
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Vietnam Package Tour from Mumbai, Vietnam Tour Packages from Mumbai </title>
                    <meta name="description" content="Book Vietnam Package Tour from Mumbai at the most Affordable Price. FOR BOOKING ☎ CALL +91-91636-76037" />
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "http://schema.org",
                            "@type": "Product",
                            "name": "Vietnam Tour Package From Mumbai Reviews",
                            "aggregateRating": {
                                "@type": "AggregateRating",
                                "ratingValue": "4.8",
                                "bestRating": "5",
                                "ratingCount": "352"
                            }
                        })}
                    </script>
                </Helmet>
                <MainHeader />
                <Vietnam_7N_8D_Mumbai_Package
                    ReviewersData={this.state.ReviewersData}
                />
                <FooterDesktop />
            </>
        );
    }
}

export default Vietnam_7N_8D_Mumbai_Page;